export default __webpack_public_path__ + "fonts/Display.woff2";